import { GoalOverviewRoadmapViewOptions } from '@griply/types';
import { getWeekStartsOn } from '@griply/utils';
import React from 'react';
import { useUser } from 'shared/hooks/use-user';

import { GroupByList } from './components/group-by-list';
import { MobileAddGoalButton } from './components/mobile-add-goal-button';
import { PageTopBar } from './components/page-top-bar';
import { Timeline } from './components/timeline';
import * as Styled from './goals-overview-calendar.style';
import { useCalendarControls } from './hooks/use-calendar-controls';
import { useFilteredGoals } from './hooks/use-filtered-goals';
import { useFilteredLocalizedLifeAreas } from './hooks/use-filtered-localized-life-areas';
import { useSelectedView } from './hooks/use-selected-view';

export const GoalsOverviewCalendar: React.FC = () => {
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);

  const { view, setView } = useSelectedView();

  const {
    timeframe,
    referenceDate,
    onMonth,
    onQuarter,
    onYear,
    onFiveYears,
    onPrev,
    onToday,
    onNext,
  } = useCalendarControls(view === GoalOverviewRoadmapViewOptions.Timeline);
  const goals = useFilteredGoals();
  const lifeAreas = useFilteredLocalizedLifeAreas(goals);

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar
            selectedView={view}
            onChangeView={setView}
            timeframe={timeframe}
            onMonth={onMonth}
            onQuarter={onQuarter}
            onYear={onYear}
            onFiveYears={onFiveYears}
            referenceDate={referenceDate}
            onPrev={onPrev}
            onToday={onToday}
            onNext={onNext}
          />

          {view === GoalOverviewRoadmapViewOptions.List && <GroupByList />}

          {view === GoalOverviewRoadmapViewOptions.Timeline && (
            <Timeline
              timeframe={timeframe}
              referenceDate={referenceDate}
              goals={goals}
              lifeAreas={lifeAreas}
              weekStartsOn={weekStartsOn}
            />
          )}
        </Styled.MainContent>
      </Styled.Main>

      <MobileAddGoalButton />
    </Styled.Container>
  );
};
